// CMoon: fills the diamond matching the photo currently in view in the mobile product gallery.
// The diamonds are rendered in Liquid right after [data-product-gallery]; this only binds them.
class SGalleryDots extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const gallery = this.previousElementSibling;
    if (!(gallery instanceof HTMLElement) || !gallery.hasAttribute('data-product-gallery')) return;

    let frame = 0;
    gallery.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => this.#update(gallery));
    }, { passive: true, signal: this.#ac.signal });
    this.#update(gallery);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #update(gallery) {
    const slides = [...gallery.children].filter((child) => child.hasAttribute('data-media-id'));
    if (!slides.length) return;
    const start = gallery.getBoundingClientRect().left;
    let active = 0;
    let best = Infinity;
    slides.forEach((slide, index) => {
      const distance = Math.abs(slide.getBoundingClientRect().left - start);
      if (distance < best) {
        best = distance;
        active = index;
      }
    });
    // At the far end the last photo cannot reach the start edge, so mark it once scrolling is complete.
    if (gallery.scrollLeft + gallery.clientWidth >= gallery.scrollWidth - 4) active = slides.length - 1;
    this.querySelectorAll('[data-gallery-dot]').forEach((dot, index) => {
      dot.classList.toggle('bg-interactive', index === active);
      dot.classList.toggle('bg-transparent', index !== active);
    });
  }
}

if (!customElements.get('s-gallery-dots')) {
  customElements.define('s-gallery-dots', SGalleryDots);
}
